import { SET_DYNAMIC_BRANDING_DATA } from '../../dynamic-branding/actionTypes';
import { getConferenceState } from '../conference/functions';
import MiddlewareRegistry from '../redux/MiddlewareRegistry';
import { I18NEXT_INITIALIZED, LANGUAGE_CHANGED } from './actionTypes';
import { changeLanguageBundle } from './functions';
import i18next from './i18next';
import logger from './logger';
/**
 * RTL languages that require right-to-left text direction.
 */
const RTL_LANGUAGES = ['fa', 'ar', 'he'];
/**
 * Updates the document language attribute (direction is always LTR).
 * RTL/LTR direction change is disabled - always uses LTR layout.
 *
 * @param {string} language - The current language code.
 * @returns {void}
 */
function updateDocumentDirection(language) {
    if (typeof document !== 'undefined') {
        // Always use LTR direction regardless of language
        document.documentElement.dir = 'ltr';
        document.documentElement.lang = language;
    }
}
/**
 * Implements the entry point of the middleware of the feature base/i18n.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => action => {
    switch (action.type) {
        case I18NEXT_INITIALIZED:
        case LANGUAGE_CHANGED:
        case SET_DYNAMIC_BRANDING_DATA: {
            const { language } = i18next;
            const { labels } = action.type === SET_DYNAMIC_BRANDING_DATA
                ? action.value
                : store.getState()['features/dynamic-branding'];
            if (language && labels?.[language]) {
                changeLanguageBundle(language, labels[language])
                    .catch(err => {
                    logger.log('Error setting dynamic language bundle', err);
                });
            }
            // Update document direction for RTL languages on init and language change
            if (action.type === I18NEXT_INITIALIZED || action.type === LANGUAGE_CHANGED) {
                updateDocumentDirection(language);
            }
            // Update transcription language, if applicable.
            if (action.type === SET_DYNAMIC_BRANDING_DATA) {
                const { defaultTranscriptionLanguage } = action.value;
                if (typeof defaultTranscriptionLanguage !== 'undefined') {
                    const { conference } = getConferenceState(store.getState());
                    conference?.setTranscriptionLanguage(defaultTranscriptionLanguage);
                }
            }
            break;
        }
    }
    return next(action);
});
